var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6131 0H5.38691C2.4118 0 0 2.4118 0 5.38691V18.6131C0 21.5882 2.4118 24 5.38691 24H18.6131C21.5882 24 24 21.5882 24 18.6131V5.38691C24 2.4118 21.5882 0 18.6131 0Z",
    fill: "#007471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65055 9.97566H9.14449V18.0228H6.65055V9.97566ZM7.92246 5.97705C8.20819 5.97706 8.48752 6.06168 8.72521 6.22026C8.9629 6.37884 9.1483 6.60426 9.25802 6.86809C9.36774 7.13191 9.39687 7.42232 9.34173 7.70269C9.28659 7.98305 9.14965 8.2408 8.94818 8.44342C8.74672 8.64604 8.48976 8.78446 8.20972 8.8412C7.92968 8.89795 7.6391 8.87049 7.37465 8.76228C7.1102 8.65407 6.88372 8.46997 6.72378 8.23319C6.56385 7.99642 6.47762 7.71758 6.47598 7.43185C6.47488 7.24119 6.51149 7.0522 6.58369 6.87575C6.65589 6.69929 6.76226 6.53885 6.89669 6.40365C7.03112 6.26845 7.19095 6.16116 7.36699 6.08795C7.54303 6.01474 7.7318 5.97705 7.92246 5.97705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7406 9.97569H13.1431V11.073C13.3836 10.6626 13.731 10.3252 14.1483 10.0968C14.5656 9.86839 15.037 9.75758 15.5123 9.77618C18.0063 9.77618 18.5134 11.4388 18.5134 13.6085V18.0228H16.0194V14.1323C16.0194 13.2012 16.0194 11.9958 14.7226 11.9958C13.4258 11.9958 13.2262 13.01 13.2262 14.0574V18.0394H10.7323L10.7406 9.97569Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.c97ec8d5c90e972c3cda17ce874e6cd9.svg";
export { ForwardRef as ReactComponent };